module.exports = __webpack_public_path__ + "img/kg.kg271f0bb.svg";